// extracted by css-extract-rspack-plugin
export default {"small_button":"tW2LT","smallButton":"tW2LT","large_button":"XC_Wg","largeButton":"XC_Wg"};